var parameterInsert={
    IdUser:'',
    NameReport:'',
    UrlReport:'', 
    User:'',
    IP:''
} 
var parameterUpdate={
    IdReportURL:'',
    NameReport:'',
    UrlReport:'', 
    Active:'1', 
    User:'',
    IP:''
} 
var parameterView={ 
    IdUser:'' 
} 
export default
{
    parameterInsert,
    parameterUpdate,
    parameterView
}